var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.291 93.5C109.862 93.5 116.875 86.4875 116.875 77.9167V42.8542C116.875 40.5167 115.316 38.9583 112.979 38.9583C110.641 38.9583 109.083 40.5167 109.083 42.8542V77.9167C109.083 82.5917 105.966 85.7083 101.291 85.7083C96.6163 85.7083 93.4997 82.5917 93.4997 77.9167V23.375C93.4997 14.8042 100.512 7.79167 109.083 7.79167C117.654 7.79167 124.666 14.8042 124.666 23.375H132.458C132.458 10.1292 122.329 0 109.083 0C95.8372 0 85.708 10.1292 85.708 23.375V77.9167C85.708 86.4875 92.7205 93.5 101.291 93.5Z",
    fill: "#EDF0F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.054 7.79102H136.354C138.692 12.466 140.25 17.9202 140.25 23.3743H148.042V171.416H15.5833V23.3743H77.9167C77.9167 17.9202 79.475 12.466 82.5917 7.79102H8.57083C3.89583 7.79102 0 11.6868 0 16.3618V178.429C0 183.104 3.89583 186.999 8.57083 186.999H155.054C159.729 186.999 163.625 183.104 163.625 178.429V16.3618C163.625 11.6868 159.729 7.79102 155.054 7.79102Z",
    fill: "#EDF0F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1247 62.334H38.958V70.1257H70.1247V62.334Z",
    fill: "#EDF0F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1247 77.918H38.958V85.7096H70.1247V77.918Z",
    fill: "#EDF0F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1247 93.5H38.958V101.292H70.1247V93.5Z",
    fill: "#EDF0F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.666 109.084H38.958V116.876H124.666V109.084Z",
    fill: "#EDF0F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.666 124.668H38.958V132.46H124.666V124.668Z",
    fill: "#EDF0F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.666 140.25H38.958V148.042H124.666V140.25Z",
    fill: "#EDF0F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.be7d97f105b6efb135486a8425e1eff6.svg";
export { ForwardRef as ReactComponent };